"use client";

import React from "react";

import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { SizeGuideProps } from "~/bff/components/SizeGuide";
import { SizeTable } from "~/components/product-details/components/size-guide/components/size-table/component";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { GCP_SIZE_GUIDE_CLASSES } from "./constants";
import { GcpSizeGuideContainer } from "./styled";

export const GcpSizeGuide: React.FC<SizeGuideProps> = ({
  title,
  description,
  sizeGuideTables,
}) => {
  return (
    <GcpSizeGuideContainer>
      <Container>
        <Typography
          component="h1"
          className={GCP_SIZE_GUIDE_CLASSES.title}
          {...getTestAutomationProps("title")}
        >
          {title}
        </Typography>
        <Typography
          className={GCP_SIZE_GUIDE_CLASSES.description}
          variant="body2"
          {...getTestAutomationProps("description")}
        >
          {description}
        </Typography>
        {sizeGuideTables?.map((table, index) => (
          <SizeTable
            className={GCP_SIZE_GUIDE_CLASSES.table}
            key={`${index}-${table?.columns?.[index]?.columnTitle}`}
            columns={table?.columns}
            tableTitle={title ?? ""}
          />
        ))}
      </Container>
    </GcpSizeGuideContainer>
  );
};
